angular.module('unergie.main')
.filter('iban', ($sce) =>
    _.memoize((val) => {
        if (!_.isEmpty(val)) {
            const v = _.filter(val.replace(/ /g, '').split(/(.{4})/))
            const result = `<span style="white-space: nowrap;"><span style="margin-right: 0.3em;">${v.join('</span><span style="margin-right: 0.3em;">')}</span></span>`
            return $sce.trustAsHtml(result)
        }
    })
)
